import React from 'react';
import {Button, Card, Checkbox, Col, Form, Input, Modal, Row} from 'antd';
import {
  GUTTER_MD,
  MARGIN_MD,
  MODAL_WIDTH_SM,
  SPAN_FULL,
  SPAN_HALF,
  SPAN_ONE_QUARTER,
  SPAN_THREE_QUARTERS
} from '../../../styles/constants';
import {
  changeAttributeFile,
  hideAttributeFileCubeTree,
  onHideAttributeFileIgnoreConcurrentUploadConfirm,
  readAttributeFileCategorisedCubes,
  readAttributeFileCube,
  setAttributeFileCube,
  showAttributeFileCubeTree,
  submitAttributeFile,
  unsetAttributeFileCube,
  uploadAttributeFileFile
} from './actions';
import {translate} from 'react-i18next';
import {compose} from 'redux';
import FileInput from '../../../components/file-input';
import {connect} from 'react-redux';
import {showAttributeFileRowList} from './row-list/actions';
import {userMustNotInsertTid} from './utils';
import Call from "../../../hocs/call";
import EnhancedTree from "../../../components/enhanced-tree";
import {getNode, getNodes, UNCATEGORIZED_CATEGORY_CODE} from "../../../utils/tree";
import {DCS_ORDERED_TREE_ROOT} from "../../../utils/treeBuilders";
import {getLocalizedStr} from "../../../middlewares/i18n/utils";
import EnhancedModal from "../../../components/enhanced-modal";
import Selector from "../../../components/selector";
import AttributeFileRowList from "./row-list";
import "./style.css";

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages,
  separator: state.scenes.dataManager.attributeFile.shared.separator,
  delimiter: state.scenes.dataManager.attributeFile.shared.delimiter,
  csvServerPath: state.scenes.dataManager.attributeFile.shared.csvServerPath,
  tid: state.scenes.dataManager.attributeFile.shared.tid,
  file: state.scenes.dataManager.attributeFile.local.file,
  refreshProdDf: state.scenes.dataManager.attributeFile.local.refreshProdDf,
  checkFiltAttributes: state.scenes.dataManager.attributeFile.local.checkFiltAttributes,
  cubeId: state.scenes.dataManager.attributeFile.local.cubeId,
  cube: state.scenes.dataManager.attributeFile.local.cube,
  categorisedCubes: state.scenes.dataManager.attributeFile.local.categorisedCubes,
  isCubeTreeVisible: state.scenes.dataManager.attributeFile.local.isCubeTreeVisible,
  isIgnoreConcurrentUploadConfirmVisible: state.scenes.dataManager.attributeFile.local.isIgnoreConcurrentUploadConfirmVisible
});

const mapDispatchToProps = dispatch => ({
  onChange: fields => dispatch(changeAttributeFile(fields)),
  onFileUpload: (file, mappingCubeId) => dispatch(uploadAttributeFileFile(file, mappingCubeId)),
  onRowListShow: () => dispatch(showAttributeFileRowList()),
  onSubmit: (separator, delimiter, cubeId, filePath, tid, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload) =>
    dispatch(submitAttributeFile(separator, delimiter, cubeId, filePath, tid, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload)),
  onHideIgnoreConcurrentUploadConfirm: () => dispatch(onHideAttributeFileIgnoreConcurrentUploadConfirm()),
  onCubeTreeShow: () => dispatch(showAttributeFileCubeTree()),
  onCubeTreeHide: () => dispatch(hideAttributeFileCubeTree()),
  onCubeSet: cubeId => dispatch(setAttributeFileCube(cubeId)),
  onCubeUnset: () => dispatch(unsetAttributeFileCube()),
  fetchCategorisedCubes: () => dispatch(readAttributeFileCategorisedCubes()),
  fetchCube: cubeId => dispatch(readAttributeFileCube(cubeId))
});

const mapPropsToFields = ({
                            cube,
                            tid,
                            file,
                            separator,
                            delimiter,
                            refreshProdDf,
                            checkFiltAttributes,
                            appLanguage,
                            dataLanguages
                          }) => ({
  cubeId: Form.createFormField({
    value:
      cube !== null
        ? `[${cube.Code}] ${getLocalizedStr(cube.labels, appLanguage, dataLanguages)}`
        : null
  }),
  tid: Form.createFormField({value: tid}),
  file: Form.createFormField({value: file}),
  separator: Form.createFormField({value: separator}),
  delimiter: Form.createFormField({value: delimiter}),
  refreshProdDf: Form.createFormField({value: refreshProdDf}),
  checkFiltAttributes: Form.createFormField({value: checkFiltAttributes})
});

const onFieldsChange = (props, fields) => props.onChange(fields);

const AttributeFile = ({
                         t,
                         form,
                         isCubeTreeVisible,
                         onCubeTreeHide,
                         fetchCategorisedCubes,
                         fetchCube,
                         categorisedCubes,
                         appLanguage,
                         dataLanguages,
                         onCubeSet,
                         onCubeUnset,
                         onCubeTreeShow,
                         cubeId,
                         cube,
                         tid,
                         onFileUpload,
                         file,
                         separator,
                         delimiter,
                         onRowListShow,
                         csvServerPath,
                         onSubmit,
                         refreshProdDf,
                         checkFiltAttributes,
                         onHideIgnoreConcurrentUploadConfirm,
                         isIgnoreConcurrentUploadConfirmVisible
                       }) =>
  <Row type="flex" justify="center">
    <Col style={{width: MODAL_WIDTH_SM}}>
      <Card type="inner">
        <Form className="advanced-form">
          <EnhancedModal
            visible={isCubeTreeVisible}
            title={t('scenes.dataManager.attributeFile.cubeTreeModal.title')}
            footer={<Button onClick={onCubeTreeHide}>{t('commons.buttons.close.title')}</Button>}
            onCancel={onCubeTreeHide}
          >
            <Call cb={fetchCategorisedCubes} disabled={categorisedCubes !== null}>
              <div className="attribute-file__tree">
                <EnhancedTree
                  searchBarSpan={SPAN_HALF}
                  tree={categorisedCubes}
                  idKey="Code"
                  nameKey="labels"
                  childrenKey="children"
                  catIdKey="CatCode"
                  catNameKey="labels"
                  unselectableKeys={
                    getNodes(categorisedCubes, 'children', node => node.children)
                      .map(node => node.CatCode)
                  }
                  hiddenIdKeys={[DCS_ORDERED_TREE_ROOT.CatCode, UNCATEGORIZED_CATEGORY_CODE]}
                  getFilter={
                    searchText =>
                      ({Code, CatCode, labels}) => {
                        const search = searchText.toLowerCase();
                        return (Code && Code.toLowerCase()
                            .indexOf(search) >= 0) ||
                          (CatCode && CatCode.toLowerCase()
                            .indexOf(search) >= 0) ||
                          getLocalizedStr(labels, appLanguage, dataLanguages)
                            .toLowerCase()
                            .indexOf(search) >= 0;
                      }
                  }
                  onSelect={
                    selectedArr => {
                      const node = getNode(
                        categorisedCubes,
                        'children',
                        node => node.children
                          ? node.CatCode === selectedArr[0]
                          : node.Code === selectedArr[0]
                      );
                      if (node !== null && node.children === undefined) {
                        onCubeSet(node.IDCube);
                      } else {
                        onCubeUnset();
                      }
                    }
                  }
                  treeActions={[
                    {
                      title: t('scenes.dataManager.attributeFile.cubeTreeModal.tree.refreshButton.title'),
                      icon: 'sync',
                      onClick: fetchCategorisedCubes
                    }
                  ]}
                  icon="cube"
                  isCustomIcon
                  getIconColor={() => "#37a0f4"}
                />
              </div>
            </Call>
          </EnhancedModal>
          <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
            <Col span={SPAN_FULL}>
              <Form.Item
                className="form-item-required"
                label={t('scenes.dataManager.attributeFile.fields.cube.label')}
              >
                {form.getFieldDecorator('cubeId')(
                  <Selector
                    selectTitle={t('scenes.dataManager.attributeFile.fields.cube.selectIcon.title')}
                    resetTitle={t('scenes.dataManager.attributeFile.fields.cube.resetIcon.title')}
                    onSelect={onCubeTreeShow}
                    onReset={onCubeUnset}
                    onDetail={null}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Call cb={fetchCube} cbParam={cubeId} disabled={cubeId === null}>
            {!userMustNotInsertTid(cube) && (
              <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                <Col span={SPAN_FULL}>
                  <Form.Item className="form-item-required"
                             label={t('scenes.dataManager.attributeFile.fields.tid.label')}>
                    {form.getFieldDecorator('tid', {
                      getValueFromEvent: e => e.target.value.toUpperCase()
                    })(<Input style={{textTransform: "uppercase"}}/>)}
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
              <Col span={SPAN_FULL}>
                <Form.Item className="form-item-required" label={t('data.csv.file.label')}>
                  {form.getFieldDecorator('file')(
                    <FileInput
                      disabled={
                        cubeId === null || cube === null ||
                        (
                          !userMustNotInsertTid(cube)
                          &&
                          (tid === null || tid.length === 0)
                        )
                      }
                      accept={'.csv'}
                      isZipAllowed
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
              <Col span={SPAN_HALF}>
                <Form.Item className="form-item-required" label={t('data.csv.separator.label')}>
                  {form.getFieldDecorator('separator')(
                    <Input
                      disabled={
                        cubeId === null || cube === null || file === null ||
                        (
                          !userMustNotInsertTid(cube)
                          &&
                          (tid === null || tid.length === 0)
                        )
                      }
                      maxLength={1}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={SPAN_HALF}>
                <Form.Item label={t('data.csv.delimiter.label')}>
                  {form.getFieldDecorator('delimiter')(
                    <Input
                      disabled={
                        cubeId === null || cube === null || file === null ||
                        (
                          !userMustNotInsertTid(cube)
                          &&
                          (tid === null || tid.length === 0)
                        )
                      }
                      maxLength={1}
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
              <Col>
                <Form.Item>
                  <Button
                    onClick={() => onFileUpload(file, cube.IDCube)}
                    disabled={
                      cubeId === null || cube === null || (
                        !userMustNotInsertTid(cube)
                        &&
                        (tid === null || tid.length === 0)
                      ) ||
                      file === null ||
                      separator === null ||
                      separator.length === 0
                    }
                    type="primary"
                    icon="upload"
                  >
                    {t('data.csv.uploadButton.label')}
                  </Button>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item>
                  <Button onClick={onRowListShow} disabled={csvServerPath === null} icon="table">
                    {t('data.csv.tableShowButton.label')}
                  </Button>
                  <AttributeFileRowList/>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={SPAN_ONE_QUARTER}>
                <Form.Item>
                  {(() => {
                    const submit = ignoreConcurrentUpload => onSubmit(
                      separator,
                      delimiter,
                      cubeId,
                      csvServerPath,
                      tid,
                      refreshProdDf,
                      checkFiltAttributes,
                      ignoreConcurrentUpload
                    );
                    return (
                      <Call
                        cb={() => Modal.confirm({
                          title: t('scenes.dataManager.attributeFile.confirms.ignoreConcurrentUpload.title'),
                          content: t('scenes.dataManager.attributeFile.confirms.ignoreConcurrentUpload.content'),
                          onOk() {
                            submit(true);
                            onHideIgnoreConcurrentUploadConfirm();
                          },
                          onCancel() {
                            onHideIgnoreConcurrentUploadConfirm();
                          },
                          cancelText: t('commons.buttons.cancel.title')
                        })}
                        disabled={!isIgnoreConcurrentUploadConfirmVisible}
                      >
                        <Button
                          onClick={() => Modal.confirm({
                            title: t('scenes.dataManager.attributeFile.confirms.submit.title'),
                            onOk() {
                              submit();
                            },
                            cancelText: t('commons.buttons.cancel.title')
                          })}
                          disabled={
                            cubeId === null ||
                            (
                              !userMustNotInsertTid(cube)
                              &&
                              (tid === null || tid.length === 0)
                            )
                            ||
                            separator === null || separator.length === 0 || csvServerPath === null
                          }
                          type="primary"
                          icon="check"
                        >
                          {t('scenes.dataManager.attributeFile.submitButton.label')}
                        </Button>
                      </Call>
                    );
                  })()}
                </Form.Item>
              </Col>
              <Col span={SPAN_THREE_QUARTERS}>
                <Row>
                  <Col span={SPAN_HALF}>
                    <Form.Item label={t('scenes.dataManager.attributeFile.refreshProdDf.label')}>
                      {form.getFieldDecorator('refreshProdDf', {valuePropName: 'checked'})(
                        <Checkbox disabled={csvServerPath === null}/>)}
                    </Form.Item>
                  </Col>
                  <Col span={SPAN_HALF}>
                    <Form.Item
                      label={t('scenes.dataManager.attributeFile.checkFiltAttributes.label')}>
                      {form.getFieldDecorator('checkFiltAttributes', {valuePropName: 'checked'})(
                        <Checkbox disabled={csvServerPath === null}/>)}
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Call>
        </Form>
      </Card>
    </Col>
  </Row>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({
    mapPropsToFields,
    onFieldsChange
  })
)(AttributeFile);



// WEBPACK FOOTER //
// ./src/scenes/data-manager/attribute-file/index.jsx